<script setup>
import AssessmentAction from '../AssessmentAction/AssessmentAction.vue'
import ProgressIndicator from '../ProgressIndicator/ProgressIndicator.vue'

const props = defineProps({
  objective: {
    type: Object,
    default: undefined,
  },
  currentStep: {
    type: String,
    default: 'assessment',
  },
  assessmentData: {
    type: Object,
    default: undefined,
  },
  currentCategoryKey: {
    type: String,
    default: undefined,
  },
})
</script>

<template>
  <li class="AssessmentObjective">
    <details class="AssessmentObjective-details" open>
      <summary class="AssessmentObjective-summary">
        <h2 class="AssessmentObjective-label">
          <ProgressIndicator
            :completed="objective.progress.completed"
            :total="objective.progress.total"
            class="AssessmentObjective-labelIndicator"
            :percentage="objective.progress.percentage"
          />
          <span class="AssessmentObjective-labelText"
            >{{ props.currentCategoryKey }}{{ props.objective.key }}
            {{ props.objective.title }}</span
          >

          <svg class="AssessmentObjective-labelIcon" aria-hidden="true">
            <use href="#arrow-down"></use>
          </svg>
        </h2>
      </summary>

      <ul class="AssessmentObjective-actions">
        <AssessmentAction
          v-for="action in props.objective.actions"
          :key="action.id"
          :action="action"
          class="AssessmentObjective-action"
          :assessment-data="props.assessmentData"
          :current-objective-key="
            props.currentCategoryKey + props.objective.key
          "
          :current-step="props.currentStep"
        >
        </AssessmentAction>
      </ul>
    </details>
  </li>
</template>
